import React from 'react';
import styled from 'styled-components';
import { LazyPicture } from '@catalogo/theme-lazy-picture';

export const SellerImage = ({ imageUrl = '' }: SellerImageProps) => (
  <Wrapper>
    <LazyPicture
      sources={{
        desktop: { src: imageUrl, ratio: '1:1' },
        mobile: { src: imageUrl, ratio: '1:1' },
      }}
      alt="logo do lojista"
      backgroundColor="#fafafa"
    />
  </Wrapper>
);

interface SellerImageProps {
  imageUrl: string | undefined;
}

const Wrapper = styled.div`
  width: 48px;
  height: 48px;
  border: 1px solid #e8e8e8;
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
